module.exports = __webpack_public_path__ + "img/T907.d17becba.jpg";